import { Toast } from "mint-ui";
import CryptoJS from 'crypto-js/crypto-js'
export default class {
    //分享appid
    IsENVDEV() {
        let appidyzl = ""
        if (ENV_DEV) {
            appidyzl = '6d877770-776f-4763-b8a2-bc2b6c22c7d1'
        } else {
            appidyzl = '3af4e56f-bc94-4740-b4f7-37b9190fe996'
        }
        return appidyzl
    }
     //验证手机
     CheckPhone(phone) {
        if (!phone) {
            Toast({
                message: "请输入手机号码",
                position: "bottom",
                duration: 1500
            });
            return false;
        
           } else {
            if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))){ 
                Toast({
                    message: "手机号码有误，请重填",
                    position: "bottom",
                    duration: 1500
                });
                
                return false; 
            } 
            return true;
        }
    }
    //加密
    encryption(data) {
        data.AppId = 'quanmaicloud';
        let strs = [];
        for (let i in data) {
            strs.push(i + '=' + encodeURIComponent(data[i]));
        }
        strs.sort();  // 数组排序
        strs = strs.join(''); // 数组变字符串
        return data;
    }
     //时间格式转换  1993-11-11
     FormatDate(time) {
            let date = new Date(time);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let M = date.getMinutes();
            M = M < 10 ? "0" + M : M;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            return y + "-" + m + "-" + d;

    }
  //将当前时间转化为年月日
    getNowFormatDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    }
    FormatDateM(time, needHour, noNeedYear) {
        if (time) {
            let date = new Date(time);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let M = date.getMinutes();
            M = M < 10 ? "0" + M : M;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            if (needHour) {
                return y + "-" + m + "-" + d + " " + h + ":" + M + ":" + s;
            }
            if (noNeedYear) {
                if (needHour) {
                    return `${m}-${d} ${h}:${M}:${s}`;
                }
                return `${m}-${d}`;
            }
            return y + "-" + m;
        } else {
            return '';
        }
    }
    //将时间戳转换为时间格式（年月日时分秒
    timestampToTime(timestamp, type) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
        var s =':'+ (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        if (type == 1) {
            return Y + M + D; //年月日
        } else if (type == 2) {
            return Y + M + D + h + m; //年月日时分
        } else if (type == 3) {
            return h + m; //时分
        }else if(type==4){
            return Y + M + D + h + m+s; //年月日时分秒
        }else if(type==5){
            return Y + M + D + '24时';
        }else if(type==6){
            return Y + M
        }
    }
    isiOS(){
        let u = navigator.userAgent;
        let iOs = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端\
        return iOs;
    }
    //年月日
    DateMonth() {
        var date = new Date();
        var Y = date.getFullYear() + '';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '';
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + '';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        return Y + '年' + M + '月' + D + '日';
    }
    //获取某个时间是否在某个时间段
    time_range(beginTime, endTime) {
        var strb = beginTime.split(":");
        if (strb.length != 2) {
            return false;
        }

        var stre = endTime.split(":");
        if (stre.length != 2) {
            return false;
        }

        var b = new Date();
        var e = new Date();
        var n = new Date();

        b.setHours(strb[0]);
        b.setMinutes(strb[1]);
        e.setHours(stre[0]);
        e.setMinutes(stre[1]);

        if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
            return true;
        } else {
            // alert ("当前时间是：" + n.getHours () + ":" + n.getMinutes () + "，不在该时间范围内！");
            return false;
        }
    }
    //获取当前周几是否在工作时间
    week_range(beginTime, endTime) {
        var b = new Date().getDay();
        if (beginTime <= b && b <= endTime) {
            return true;
        } else {
            return false
        }
    }
     /**
     * 判断当前是支付宝还是微信  1-微信
     */
    isAlipayOrWechat() {
        var userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.match(/MicroMessenger/i) == "micromessenger") return 1;
        return 0;
    }

}


// WEBPACK FOOTER //
// ./src/util/base.js